var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Pane',{attrs:{"title":'重新提交物资采购记录'}}),_c('div',{staticClass:"container"},[_c('a-spin',{attrs:{"spinning":_vm.loading}},[(_vm.editData)?_c('PurchaseMaterialsForm',{ref:"form",attrs:{"editData":_vm.editData},on:{"submit":_vm.handleSubmit,"close":_vm.handleClose}}):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }